import { createFileRoute } from '@tanstack/react-router'
import { useRouteDigitalProductId } from '@/shared/hooks/useRouteDigitalProductId'

import { DigitalProductLiveStreams } from '@/features/live-streams/Show'

export const Route = createFileRoute(
  '/_event/transmissoes/$liveStreamId'
)({
  component: DigitalProductLiveStreamShowPage
})

function DigitalProductLiveStreamShowPage() {
  const digitalProductId = useRouteDigitalProductId()
  const { liveStreamId } = Route.useParams()

  return (
    <DigitalProductLiveStreams
      digitalProductId={digitalProductId}
      id={liveStreamId}
    />
  )
}
